import { withDimensions } from '../../../hoc/with-dimensions';
import { FocusedLayout as FocusedLayoutComponent } from './focused-layout';
export var FocusedLayout = withDimensions(FocusedLayoutComponent);
//# sourceMappingURL=index.js.map